const actions = {
  SET_STATE: 'crm/SET_STATE',
  FETCH_DATA_BY_FILTER: 'crm/FETCH_DATA_BY_FILTER',
}

export default actions
